import { get } from 'lodash';
import { convertHexToRGB } from '../../utils';

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: get(theme, 'color.uiBackground'),
  },
  listButton: {
    backgroundColor: `${convertHexToRGB(get(theme, 'color.bodyText'), 0.05)} !important`,
    color: `${convertHexToRGB(get(theme, 'color.bodyText'), 0.8)} !important`,
    fontFamily: get(theme, 'typography.bodyText'),
    fontSize: get(theme, 'fontSize.bodyText'),
  },
  dropdownIndicator: {
    color: `${convertHexToRGB(get(theme, 'color.bodyText'), 0.5)} !important`,
  },
  listItem: {
    backgroundColor: get(theme, 'color.uiBackground'),
    color: get(theme, 'color.bodyText'),
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/ExpandableList/styles.js